import { Columns } from '../../columns'

export const DefaultPerformanceColumns = [
    Columns.RPC,
    Columns.Cost,
    Columns.Sales,
    Columns.ACOS,
    Columns.ROAS,
    Columns.Impressions,
    Columns.Clicks,
    Columns.CTR,
    Columns.Orders,
    Columns.CVR,
    Columns.CAC,
    Columns.AOV,
]
